import cl from 'cloudinary-core';

import OPTIONS from './cloudinary_options.js';

export default class cloudinaryController {
  constructor() {
    this.cloudinary = cl.Cloudinary.new({ cloud_name: 'devex' });
    this.options = {
      type: 'fetch'
    };

    this.url = null;
  }

  /**
   * Checks if an option object restrictions break with the current Cloudinary options
   * If it breaks it throws an error that stops the function execution
   *
   * @param {object} option - Option object
   *
   * @returns {boolean|undefined} - True if the restrictions are clear, undefined if not
   */
  passesOptionRestrictions(option) {
    option.restrictions.forEach(restriction => {
      const key = restriction.name;

      if(this[key] && restriction.value.indexOf(this[key]) === -1) {
        throw new Error(`${ option.name } cannot be used with '${ this[key] }' ${ key }`);
      }
    });

    return true;
  }

  /**
   * Checks which Cloudinary options are on the scope and adds them to the options object
   *
   * @returns {undefined}
   */
  checkOptionParams() {
    OPTIONS.forEach(option => {
      const simple = typeof option === 'string';
      const key = simple ? option : option.name;

      if(this[key] && (simple || this.passesOptionRestrictions(option))) {
        this.options[key] = this[key];
      }
    });
  }

  /**
   * Generates a key-value object with the styles based on the url
   *
   * @returns {object} - Object with key-value styles (or empty if no url)
   */
  getBackgroundImageStyle() {
    if(!this.url) {
      return {};
    }

    return { 'background-image': 'url(' + this.url + ')' };
  }

  /**
   * Fires checkOptionParams and stores the generated URL on the scope
   *
   * @returns {undefined}
   */
  $onInit() {
    this.checkOptionParams();

    this.url = this.cloudinary.url(this.publicId, this.options);

    if(this.container) {
      this.backgroundImageStyle = this.getBackgroundImageStyle();
    }
  }
}
